import { getAvailableMemberRewardCount } from '../../../loyalty/utils/member-reward-utils';
import { getAvailableDiscountQuantity } from '../../../sales-data/utils/items/item-discount-utils';
import { isDiscountItemPrice, isMemberRewardItemPrice } from '../../../sales-data/utils/items/item-price-utils';
import { getOrderItemCountByItemId } from './get-order-item-count-by-item-id';
export const getAllowedOrderItemQuantityForRestrictedPrice = (itemPrice, itemId, includeExistingOrderItemCount) => {
    if (isDiscountItemPrice(itemPrice)) {
        return getAllowedDiscountedPriceCount(itemId, itemPrice.discountId, includeExistingOrderItemCount);
    }
    if (isMemberRewardItemPrice(itemPrice)) {
        return getAllowedMemberRewardPriceCount(itemId, itemPrice.rewardId, includeExistingOrderItemCount);
    }
    return 0;
};
const getAllowedDiscountedPriceCount = (itemId, discountId, includeExistingOrderItemCount) => {
    const availableDiscountQuantity = getAvailableDiscountQuantity(discountId);
    if (!includeExistingOrderItemCount)
        return availableDiscountQuantity;
    const totalSelectedDiscountedOrderItems = getOrderItemCountByItemId(itemId, { discountId });
    return availableDiscountQuantity + totalSelectedDiscountedOrderItems;
};
const getAllowedMemberRewardPriceCount = (itemId, rewardId, includeExistingOrderItemCount) => {
    const availableMemberRewardCount = getAvailableMemberRewardCount(rewardId);
    if (!includeExistingOrderItemCount)
        return availableMemberRewardCount;
    const existingOrderItemCount = getOrderItemCountByItemId(itemId, { rewardId });
    return availableMemberRewardCount + existingOrderItemCount;
};
